//code sourced from: https://stackoverflow.com/questions/41889384/angular2-validation-for-input-type-file-wont-trigger-when-changing-the-fi/41938495#41938495


import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  // tslint:disable-next-line
  selector: 'input[type=file]', // eslint-disable-line
  // bug 66468
  host: {
    // eslint-disable-line
    '(change)': 'onFileChange($event)',
    '(blur)': 'onTouched()',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileValueAccessorDirective,
      multi: true,
    },
  ],
})
// https://github.com/angular/angular/issues/7341
export class FileValueAccessorDirective implements ControlValueAccessor {
  value: any;
  /* eslint-disable @typescript-eslint/no-empty-function */
  onChange = (_: FileList | null) => {};
  onTouched = () => {};

  writeValue(value) {}
  onFileChange(event: Event) {
    this.onChange((event.target as HTMLInputElement).files);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
